import { useState } from "react";
import { Link } from "react-router-dom";
import { CaretDown, CaretRight, Info } from "@phosphor-icons/react";
import { Section, KPI, useMoney } from "./shared";

export default function SummarySection({ r }) {
  const { fmt } = useMoney();
  const s = r.summary;
  const [openNoCost, setOpenNoCost] = useState(false);
  return (
    <Section id="resumen" num={1} title="Resumen general del mes"
      desc={`${r.rule} Inventario = fotografía actual (hoy), no histórica.`}>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-3" data-testid="mr-summary-kpis">
        <KPI label="Venta total" value={fmt(s.sales_total_mxn)} tone="primary" testid="kpi-sales-total"
          sub={s.repair_sales_mxn > 0 ? `Productos ${fmt(s.products_sales_mxn)} · Reparación ${fmt(s.repair_sales_mxn)}` : undefined} />
        <KPI label="Notas de venta" value={s.notes_count} sub={s.repair_notes_count > 0 ? `${s.product_notes_count} productos · ${s.repair_notes_count} reparación` : undefined} testid="kpi-notes" />
        <KPI label="Productos vendidos" value={s.units_sold} sub="piezas" testid="kpi-units" />
        <KPI label="Ticket promedio" value={fmt(s.avg_ticket_mxn)} testid="kpi-ticket" />
        <KPI label="Clientes que compraron" value={s.clients_count} sub={`${s.new_clients_count} nuevos · ${s.recurrent_clients_count} recurrentes · ${s.returned_clients_count} regresaron`} testid="kpi-clients" />
        <KPI label="Utilidad bruta estimada" value={fmt(s.gross_profit_mxn)} tone={s.gross_profit_mxn >= 0 ? "good" : "bad"} sub={`margen ${s.gross_margin_pct}% · costo actual`} testid="kpi-gross" />
        <KPI label="Pendiente por cobrar" value={fmt(s.pending_mxn)} tone={s.pending_mxn > 0 ? "warn" : "muted"} sub="de las notas de este mes" testid="kpi-pending" />
        <KPI label="Inventario · piezas" value={s.inventory_pieces} sub="stock actual" testid="kpi-inv-pieces" />
        <KPI label="Inventario a costo" value={fmt(s.inventory_cost_mxn)} testid="kpi-inv-cost" />
        <KPI label="Inventario a precio tienda" value={fmt(s.inventory_store_mxn)} sub={`utilidad potencial ${fmt(s.inventory_profit_mxn)}`} testid="kpi-inv-store" />
      </div>

      {s.no_cost_notes.length > 0 && (
        <div className="border border-amber-200 bg-amber-50/60 rounded-sm" data-testid="mr-no-cost-notes">
          <button type="button" onClick={() => setOpenNoCost((v) => !v)} className="w-full flex items-center gap-2 px-3 py-2 text-left text-xs text-amber-900">
            {openNoCost ? <CaretDown size={12} weight="bold" /> : <CaretRight size={12} weight="bold" />}
            <Info size={13} weight="bold" />
            <span><b>{s.no_cost_notes.length} nota(s)</b> no tienen costo registrado en alguna partida (concepto libre o reparación): se cuentan en la venta pero quedan fuera de la utilidad.</span>
          </button>
          {openNoCost && (
            <ul className="px-3 pb-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-1 text-xs">
              {s.no_cost_notes.map((n) => (
                <li key={n.id} className="flex items-center justify-between gap-2 bg-white border border-amber-100 px-2 py-1">
                  <span><Link to="/sales" className="font-mono-data font-semibold text-[#002FA7] hover:underline">#{String(n.folio).padStart(6, "0")}</Link> <span className="text-zinc-500">· {n.client}</span></span>
                  <span className="numeric text-zinc-700">{fmt(n.total_mxn)} <span className="text-[10px] text-amber-700">{n.reason}</span></span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </Section>
  );
}
